/*
 * Glitch site pass, Sep 2026. Lead events for GA4 and Google Ads.
 * Pushes to window.dataLayer, and to gtag when it exists. Never sends a page view:
 * the app-loaded Google tag owns page views.
 *
 * Calls and emails: a click on any tel: or mailto: link.
 * Jotform leads: the forms are iframes, so the page never sees their submit. The frame
 * posts { action: 'submission-completed', formID } to the parent on submit (the shape
 * Jotform's own embed handler reads, jsform script, Sep 2026). It may arrive as an object
 * or a JSON string. The form id picks the event name.
 * Native contact form: its own submit. Registration start: a click on a registration link
 * (delegated, since SparkLayer injects some of those links after load).
 */
(function () {
  'use strict';

  // Form ids from _local/shopify/config.json formIds. A Jotform transfer keeps the ids.
  var FORM_EVENTS = {
    '260015038439048': 'lead_contact',
    '260074494311149': 'lead_quote',
    '261826098092161': 'lead_government',
    '253638831939067': 'lead_registration',
    '260705339187159': 'lead_registration'
  };
  var JOTFORM_ORIGIN = /^https:\/\/([a-z0-9-]+\.)*jotform\.com$/i;

  window.dataLayer = window.dataLayer || [];

  function send(name, formId) {
    var params = { page_path: window.location.pathname, form_id: formId || '' };
    window.dataLayer.push(Object.assign({ event: name }, params));
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (/^tel:/i.test(href)) send('lead_call');
    else if (/^mailto:/i.test(href)) send('lead_email');
    else if (/regist/i.test(href)) send('lead_registration_start');
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var type = form.querySelector('input[name="form_type"]');
    if (type && type.value === 'contact') send('lead_contact', 'shopify-contact');
  }, true);

  window.addEventListener('message', function (event) {
    if (!JOTFORM_ORIGIN.test(event.origin || '')) return;
    var data = event.data;
    if (typeof data === 'string') {
      if (data.indexOf('submission-completed') === -1) return;
      try { data = JSON.parse(data); } catch (e) { return; }
    }
    if (!data || data.action !== 'submission-completed') return;
    var formId = String(data.formID || '');
    send(FORM_EVENTS[formId] || 'lead_form', formId);
    // F9: release the custom.css height floor, so the short thank-you screen does not sit above blank space.
    if (/^\d+$/.test(formId)) {
      var frames = document.querySelectorAll('iframe[id^="' + formId + '"]');
      for (var i = 0; i < frames.length; i++) frames[i].style.minHeight = '0px';
    }
  });
})();
